import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Form, Row } from 'react-bootstrap'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Cookies from 'js-cookie'
import axios from 'axios'
import toast from 'react-hot-toast'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'


const ChangePlot = () => {
  const { booking_id } = useParams()
  const location = useLocation()
  const bookingData = location.state?.booking
  console.log('Previous booking data:', bookingData)

  const [finalDiscount, setFinalDiscount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [changePlotData, setChangePlotData] = useState({
    user_id: '1234',
    site_name: '',
    plot_number: '',
    plot_id: '',
    site_id: '',
    customer_name: '',
    broker_id: '',
    actual_price: '',
    final_price: null,
    booking_price_in_words: '',
    plot_size: '',
    discount_price: '',
    booking_amount: '',
    booking_payment_status: '',
    booking_status: 'BOOKED',
    due_date: '',
    booking_date: '',
    payment_method: '',
    online_transaction_number: '',
  })

  const [siteNames, setSiteNames] = useState([])
  const [sitePlots, setSitePlots] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)

      const token = Cookies.get('authToken') // Retrieve token from cookies

      try {
        const [sitesRes] = await Promise.all([
          axios.get(BASE_URL+'/sites', {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }),
        ])

        setSiteNames(sitesRes.data.data)
      } catch (err) {
        toast.error('Failed to fetch data')
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  const handleSiteSelect = async (e) => {
    const selectedSiteId = Number(e.target.value)
    setChangePlotData({
      site_name: selectedSiteId,
      plot_number: '',
      plot_id: '',
    })
    console.log("New selected Site's ID:", selectedSiteId)
    const token = Cookies.get('authToken')

    try {
      const response = await axios.get(
        BASE_URL+`/site/plots?id=${selectedSiteId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      )
      const availablePlots = response.data.data.filter(
        (plot) => plot.status === 'AVAILABLE',
      )
      setSitePlots(
        availablePlots.length
          ? availablePlots
          : [{ id: 0, plot_number: 'No plot available', disabled: true }],
      )
    } catch (err) {
      toast.error('Failed to fetch plots for selected site')
    }
  }

  const [oldPlotPrice, setOldPlotPrice] = useState()
  const [newPlotPrice, setNewPlotPrice] = useState()
  const [priceDifference, setPriceDifference] = useState()
  const handlePlotSelect = (e) => {
    const selectedPlotId = Number(e.target.value)
    const selectedPlot = sitePlots.find((plot) => plot.id === selectedPlotId)
    if (selectedPlot) {
      setChangePlotData({
        ...changePlotData,
        plot_number: selectedPlot.plot_number,
        plot_id: selectedPlot.id,
        plot_size: selectedPlot.plot_size,
        actual_price: selectedPlot.price,
      })
      console.log("New Plot's Id:", selectedPlot.id)

      const finalPrice = selectedPlot.final_price
      setNewPlotPrice(finalPrice)

      console.log('New Final Price during Updating:', finalPrice)
    }
  }
  useEffect(() => {
    if (oldPlotPrice !== null && newPlotPrice !== null) {
      const difference = newPlotPrice - oldPlotPrice
      setPriceDifference(difference)
    }
  }, [oldPlotPrice, newPlotPrice])

  const navigate = useNavigate()
  useEffect(() => {
    const token = Cookies.get('authToken')
    if (!token) {
      console.error('Authentication required. Please log in.')
      return
    }

    setLoading(true)
    axios
      .get(BASE_URL+`/get/booking?id=${booking_id}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const bookingData = response.data?.data?.[0]
        console.log('Fetched new booking transaction data:', bookingData)

        if (bookingData) {
          setBookingTrans(bookingData)
          setOldPlotPrice(bookingData.booking_price)
          setFinalAmount(bookingData.final_price)
          setChangePlotData(bookingData.discount_price)
          setFinalDiscount(bookingData.final_price)
          setChangePlotData((prevData) => ({
            ...prevData,
            final_price: bookingData.final_price,
            discount_price: bookingData.discount_price,
            booking_price: bookingData.booking_price,
            booking_amount: bookingData.booking_price,
          }))

          console.log('Final Price during Booking:', bookingData.final_price)
          console.log(
            'Booking Price during Booking:',
            bookingData.booking_price,
          )
        }
      })
      .catch((err) => {
        console.error('Error fetching transaction:', err)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [booking_id])
  const [bookingTrans, setBookingTrans] = useState()

  const [finalAmount, setFinalAmount] = useState(0)
  const inputHandler = (e) => {
    const { name, value } = e.target
    setChangePlotData((prevData) => ({
      ...prevData,
      [name]: value,
      ...(name === 'booking_price' && { booking_amount: value }),
    }))

    if (name === 'final_price') {
      const newPrice = Number(value)
      setPriceDifference(newPrice - finalAmount)
    }
    console.log('Updated booking_price:', value)
  }

  const handleDiscount = (e) => {
    const discount = e.target.value || 0
    console.log(discount)
    console.log(changePlotData)
    setChangePlotData((prevData) => {
      const newFinalPrice = finalDiscount - discount

      setFinalAmount(newFinalPrice)

      console.log('HandleFinalPriceDiscount: ', newFinalPrice)
      return {
        ...prevData,
        discount_price: e.target.value,
        final_price: newFinalPrice,
      }
    })

    setPriceDifference((prevData) => {
      const finalPrice = parseFloat(changePlotData.final_price) || 0
      return finalPrice - discount - finalAmount
    })

    console.log('Discount applied:', discount)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)
    const token = Cookies.get('authToken')
    if (!token) {
      toast.error('Authentication required. Please log in.')
      return
    }

    const payload = {
      ...changePlotData,
      id: booking_id,
      new_site_id: changePlotData.site_name,
      new_plot_id: changePlotData.plot_id,
      booking_amount: changePlotData.booking_price,
      final_price: changePlotData.final_price,
      discount_price: changePlotData.discount_price,
    }
    console.log('Payload being sent:', payload)

    axios
      .post(
        BASE_URL+`/booking/update?booking_id=${booking_id}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        console.log('Plot updated successfully:', response.data)
        toast.success(response.data.message)
        navigate('/allbooking')
      })
      .catch((err) => {
        if (err.response) {
          console.error('Error response:', err.response.data)
        } else {
          console.error('Error:', err.message)
        }
      })
  }
  return (
<Container className="pb-3" style={{fontFamily: theme.font.family }}>

      <Form className="text-start mt-0 px-3 rounded-3" onSubmit={handleSubmit} style={{backgroundColor: theme.colors.background}}>


        
         <p className="mb-4 fw-bold" style={{ color: theme.colors.primary, borderBottom: `2px solid ${theme.colors.secondary} `, paddingBottom: '8px' , fontSize: '1.5rem'}}>
        
                  Update Booking ID <span style={{ color:theme.colors.secondary, 
                  // backgroundColor: `${theme.colors.secondary}20`
        
                  
                   padding: '2px 5px', borderRadius: '5px' }}>{booking_id}</span>
        
          </p>
        <Row>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="site_name">Site Name</Form.Label>
            <Form.Select
              id="site_name"
              name="site_name"
              // value={changePlotData.site_name}
              onChange={handleSiteSelect}
              required
            >
              <option value="">Select site</option>
              {siteNames.map((site) => (
                <option key={site.id} value={site.id}>
                  {site.name}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="plot_number">Select Plot Number</Form.Label>
            <Form.Select
              id="plot_number"
              name="plot_number"
              value={setChangePlotData.plot_id}
              onChange={handlePlotSelect}
              required
            >
              {sitePlots.length > 0 && sitePlots[0].id !== 0 ? (
                <option value="">Select a plot</option>
              ) : (
                <option value="No plots available"></option>
              )}

              {sitePlots.map((plot) => (
                <option key={plot.id} value={plot.id}>
                  {plot.plot_number}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
        {priceDifference !== null && changePlotData.plot_id && (
          <Row className="mt-3 mb-4">
            <Col>
              <div
                style={{
                  border:
                    priceDifference >= 0 ? '1px solid green' : '1px solid red',
                  borderRadius: '8px',
                  backgroundColor: '#f8f9fa',
                  padding: '15px',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  color: priceDifference >= 0 ? 'green' : 'red',
                  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                }}
              >
                <h4 className="fw-bold">Price Difference :</h4>
                <p style={{ fontSize: '1.2rem' }}>
                  {priceDifference > 0
                    ? `The new plot price is ₹ ${priceDifference} more than the old plot price. Would you like to continue?`
                    : priceDifference < 0
                    ? `The new plot price is ₹ ${Math.abs(
                        priceDifference,
                      )} less than the old plot price. Would you like to continue?`
                    : 'The plot final price has not changed.'}
                </p>
              </div>
            </Col>
          </Row>
        )}
        <Row>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="plot_size">Plot Size</Form.Label>
            <Form.Control
              type="text"
              id="plot_size"
              name="plot_size"
              value={changePlotData.plot_size}
              onChange={handlePlotSelect}
              disabled
            />
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="customer_name">Customer Name</Form.Label>
            <Form.Control
              id="customer_name"
              name="customer_name"
              value={bookingData.customer_name}
              // onChange={inputHandler}
              disabled
            ></Form.Control>
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="broker_id">Associate Name</Form.Label>
            <Form.Control
              id="broker_id"
              name="broker_id"
              value={bookingData.broker_name}
              // onChange={inputHandler}
              disabled
            ></Form.Control>
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="actual_price">Actual Amount</Form.Label>
            <Form.Control
              type="number"
              id="actual_price"
              name="actual_price"
              value={changePlotData?.actual_price}
              // onChange={inputHandler}
              disabled
            />
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="final_price">Final Amount</Form.Label>
            <Form.Control
              type="number"
              id="final_price"
              name="final_price"
              value={
                changePlotData.final_price ? changePlotData.final_price : null
              }
              onChange={inputHandler}
              disabled
            />
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="discount_price">Discount</Form.Label>
            <Form.Control
              type="text"
              id="discount_price"
              name="discount_price"
              value={changePlotData.discount_price}
              onChange={handleDiscount}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="booking_price">Booking Amount</Form.Label>
            <Form.Control
              type="number"
              id="booking_price"
              name="booking_price"
              value={
                changePlotData.booking_price ?? changePlotData.booking_amount
              }
              onChange={inputHandler}
            />
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="booking_status">Booking Status</Form.Label>
            <Form.Control
              id="booking_status"
              name="booking_status"
              value={bookingTrans?.booking_status}
              disabled
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="payment_method">Payment Method</Form.Label>
            <Form.Control
              id="payment_method"
              name="payment_method"
              value={bookingTrans?.payment_method || ''}
              disabled
            />
          </Col>

          <Col md={6} className="mb-3">
            <Form.Label htmlFor="online_transaction_number">
              {bookingTrans?.payment_method === 'CASH'
                ? 'Not Mandatory'
                : bookingTrans?.payment_method === 'CHEQUE'
                ? 'Cheque Number'
                : 'Online Transaction Number'}
            </Form.Label>
            <Form.Control
              id="online_transaction_number"
              name="online_transaction_number"
              value={bookingTrans?.online_transaction_number}
              placeholder={
                bookingTrans?.payment_method === 'CASH'
                  ? 'N/A'
                  : bookingTrans?.payment_method === 'CHEQUE'
                  ? 'Enter Cheque Number'
                  : 'Enter Online Transaction Number'
              }
              disabled={
                bookingTrans?.payment_method === 'CASH' ||
                bookingTrans?.payment_method === 'ONLINE' ||
                bookingTrans?.payment_method === 'CHEQUE'
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="booking_payment_status">
              Booking Payment Status
            </Form.Label>
            <Form.Control
              id="booking_payment_status"
              name="booking_payment_status"
              value={bookingTrans?.booking_payment_status}
              disabled
            />
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="booking_date">Booking Date</Form.Label>
            <Form.Control
              id="booking_date"
              name="booking_date"
              value={bookingTrans?.booking_date}
              disabled
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className="mb-3">
            <Form.Label htmlFor="due_date">Due Date</Form.Label>
            <Form.Control
              id="due_date"
              name="due_date"
              value={bookingTrans?.due_date}
              disabled
            />
          </Col>
        </Row>

        <div className="d-grid mt-4">
          <Button type="submit" style={{backgroundColor: theme.colors.primary, border:'none', }} className="text-white">
            Update Booking
          </Button>
        </div>
      </Form>
    </Container>
  )
}

export default ChangePlot
